/**
 * Turns a raw people-status value into a human-readable label.
 * Multi-word PascalCase statuses (e.g. "MemberRejected") are split on their
 * camelCase boundaries so they render as separate words ("Member Rejected").
 * Single-word statuses ("Yes", "No", "Applied") are returned unchanged.
 */
const formatStatus = (status) => {
  if (!status) return status;
  return String(status).replace(/([a-z])([A-Z])/g, '$1 $2');
};

export default formatStatus;
